import React from 'react';
import {
  Text,
  Hero,
  Space,
  spacing,
  Container,
  Row,
  Column,
} from '@dylanlewis/shared';

import { FormContainer } from '../../Form/FormContainer';
import { unsubscribe } from '../../../common/forms';
import serialize from 'form-serialize';
import { Mutation } from 'react-apollo';
import { UNSUBSCRIBE } from '../mutations/mutations';
import styled from 'styled-components';
import { Box } from 'rebass';

const StyledBox = styled(Box)`
  min-height: 100vh;
  background: #8f8e8d;
  padding-bottom: 100px;
`;
export class PageUnsubscribe extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      errors: {},
      emailHasBeenSent: false,
    };
  }

  validateForm(obj) {
    let errors = {};

    unsubscribe().forEach(field => {
      const { name, required } = field;

      if (required && !obj[name]) {
        errors[name] = 'Required';
      }

      if (obj.email) {
        let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        let isEmail = re.test(String(obj.email).toLowerCase());
        if (!isEmail) {
          errors.email = 'Invalid email address';
        }
      }
    });

    if (Object.keys(errors).length) {
      this.setState({ errors: errors });
      return true;
    } else {
      this.setState({ errors: {} });
      return false;
    }
  }

  render() {
    const { page, heroDetails } = this.props;

    const onSubmit = async (e, send) => {
      e.preventDefault();

      var obj = serialize(e.target, { hash: true });

      const hasErrors = this.validateForm(obj);

      if (hasErrors) return null;

      await send({
        variables: {
          input: {
            ...obj,
          },
        },
      });

      if (e && e.target) e.target.reset();

      return null;
    };

    return (
      <Container>
        <Hero
          renderVisual={heroDetails.visual}
          subtitle={heroDetails.subtitle}
          title={heroDetails.title}
        >
          {heroDetails.content && (
            <Text size="body" as="span" html={heroDetails.content} />
          )}
        </Hero>
        <Space bottom size={spacing.space10}>
          <Space padding bottom size={spacing.space5}>
            <Row justifyContent="center">
              <Column width={[1, 8 / 12]} mx="auto" flex="0 0 auto" mb={[4, 0]}>
                {!this.state.emailHasBeenSent ? (
                  <Mutation
                    mutation={UNSUBSCRIBE}
                    onCompleted={response => {
                      if (response.unsubscribe) {
                        this.setState({ emailHasBeenSent: true });
                      }
                    }}
                    onError={() => this.setState({ emailError: true })}
                  >
                    {(send, { loading, error }) => {
                      return (
                        <FormContainer
                          form={unsubscribe(this.state.errors)}
                          isLoading={loading}
                          onSubmit={e => onSubmit(e, send)}
                          buttonText="Update Preferences"
                        />
                      );
                    }}
                  </Mutation>
                ) : (
                  <Text>
                    You have been removed from our mailing list. Should you wish
                    to resubscribe in the future, you can do so via our website.
                  </Text>
                )}
              </Column>
            </Row>
          </Space>
        </Space>
      </Container>
    );
  }
}
